import { Component, ViewEncapsulation } from '@angular/core'
import { PageUtil } from "@bequeathed/ngx-utils"
import { BaseInputControl } from '../base-input-control/base-input-control.component'
import { LoggerService } from "@bequeathed/ngx-app-core"

const LOG: LoggerService = LoggerService.get('BaseSelectionControl');

/**
 * Base control for all select and multi-select controls
 *
 * @author Dan Bennett (dbennett)
 */
@Component({
    standalone: true,
    selector: 'base-selection-control',
    templateUrl: './base-selection-control.component.html',
    styleUrls: [
        '../base-input-control/base-input-control.component.sass',
        '../../base-form/base-form.component.sass'
    ],
    encapsulation: ViewEncapsulation.None
})
export class BaseSelectionControl extends BaseInputControl {

    override setModelValue(val: any): void {
        this.control.setValue(val);
        this.modelValue = val;
        this.modelValueChange.emit(this.modelValue);
    }

    override focus(): void {
        const nativeElement: any = PageUtil.findNativeElement(`${this.question.id}-${this.convertWhitespaces(this.getFirstOption())}`);
        if (nativeElement) {
            nativeElement.focus();
        }
    }

    getFirstOption(): string {
        LOG.debug('getFirstOption', 'Retrieving first option');
        return this.question.acceptedValues!
            .entries()
            .next().value;
    }
}
